import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';
import { useAppStore } from '../store.js';
export function useChatAttention() {
  const userId = useAppStore((s) => s.session?.user.internalId);
  return useQuery({
    queryKey: ['chat-attention', userId],
    queryFn: api.chatAttention,
    enabled: !!userId,
    staleTime: 10000,
    refetchInterval: 15000,
    refetchIntervalInBackground: false,
    retry: false,
  });
}
